import React, { useState, useContext, useRef } from 'react'
import { useTranslate, projectContext } from '../../../lib'
import { InputNesting, TextareaNesting } from '../../common/Inputs/Input'
import ButtonYesNo from '../../common/ButtonYesNo'
import BoxInfo from '../../common/BoxInfo'
import { SelectNesting } from '../../common/Inputs/Select'

export default function CallSettings({
  showCallSettings, setShowCallSettings,
  channel, setChannel,
  subCampaings, setSubCampaings,
  campaings, setCampaings,
  category, setCategory,
  transcription, setTranscription,
  translationAssessment, setTranslationAssessment,
  selectedProject, setSelectedProject,
  selectedSubCampaignId, setSelectedSubCampaignId,
  campaign_ref, subcampaing_ref,
  minimum_passing_score_ref,
  industries, avatarPreview, handleAvatarChange,
  welcome_mesageRef, showOuboundMessage
}) {
  const { t } = useTranslate()

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center w-100'>
          <div
            className='w-100'
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowCallSettings(!showCallSettings)} style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }} className='m-0'>
              {t('menu.genai.callSettings')}
            </h2>

            {!showCallSettings && (
              <button type='button' className='ml-3' onClick={() => setShowCallSettings(true)}>
                <img src='/icons/arrow_down.png' alt='' style={{ width: 15 }} />
              </button>
            )}

            {showCallSettings && (
              <button type='button' className='ml-3' onClick={() => setShowCallSettings(false)}>
                <img src='/icons/arrow_up.png' alt='' style={{ width: 15 }} />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showCallSettings ? 'flex' : 'none',
          backgroundColor: '#0088ff10',
          padding: '5px 10px 10px 10px',
          position: 'relative'
        }}
        className='flex-column w-100 pt-5'
      >
        <div className='d-flex flex-row flex-wrap pb-4 mt-1'>
          <div className="inputs" style={{ marginRight: 40 }}>
            <div className="input flex flex-row items-center">
              <BoxInfo
                id="bottype-tp" titleClass='mr-0-4'
                title={`${t('menu.genai.botType')}:`} styles={{ whiteSpace: 'nowrap' }}
                place="top" containerClass='mr-0-5'
                content={t('menu.genai.botTypeTooltip')}
              />
              <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                <ButtonYesNo
                  onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                  width={170}
                  state={channel === "chat" ? false : true}
                  height={30}
                  Yes={t('menu.voiceBot')}
                  No={t('menu.chatBot')}
                />
              </div>
            </div>
          </div>
          <div className="inputs" style={{ marginRight: 40, minWidth: 350 }}>
            <div className="input d-flex flex-row align-items-center">
              <span style={{ minWidth: 112 }}>{t('menu.genai.interactionType')}:</span>
              <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                <ButtonYesNo
                  onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                  width={170}
                  state={category === "outbound" ? false : true}
                  height={30}
                  Yes={t('common.inbound')}
                  No={t('common.outbound')}
                />
              </div>
            </div>
          </div>

          <div className="inputs" style={{ minWidth: 150 }}>
            <div className="input d-flex flex-row align-items-center w-100">

              <div className='d-flex flex-row align-items-center'>
                <span style={{ minWidth: 140, whiteSpace: 'nowrap', marginRight: 10 }}>
                  {t('menu.genai.transcriptionEnable')}:
                </span>
                <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                  <ButtonYesNo
                    onClick={() => setTranscription((prev) => prev == 0 ? 1 : 0)}
                    width={180}
                    state={transcription}
                    height={30}
                    Yes={t('common.true')}
                    No={t('common.false')}
                  />
                </div>
              </div>

              {/* <div className='d-flex flex-row align-items-center ml-2'>
                <span style={{ whiteSpace: 'nowrap' }} className=''>{t('menu.genai.translationAssesment')}:</span>
                <div className="list_call_type d-flex flex-row align-items-center" style={{ marginLeft: 5 }}>
                  <ButtonYesNo
                    onClick={() => setTranslationAssessment(prev => !prev)}
                    width={170}
                    state={translationAssessment}
                    height={30}
                    Yes={t('menu.enabled')}
                    No={t('menu.disabled')}
                  />
                </div>
              </div> */}

            </div>
          </div>

          {category === "outbound" && 
            <div className="d-flex flex-row w-100 mt-2">
              <TextareaNesting
                containerClass="mr-1"
                style={{ flexGrow: '1', minWidth: 620 }}
                ref={welcome_mesageRef}
                id="outbound_mesage"
                type="text"
                row={2}
                title={t('menu.genai.outboundCallMessage')}
              />
            </div>
          }

          <div className='d-flex flex-row align-items-center w-100 mt-3'>
            <SelectNesting
              ref={campaign_ref} id="campaing"
              title={`${t('common.campaign')}:`} containerClass="mr-2"
            >  {campaings.map((item, index) => (<option key={`campaign ${index + 1}:`} value={item.id}>{item.name}</option>))}
            </SelectNesting>

            <SelectNesting
              ref={subcampaing_ref} id="subcampaing"
              title={`${t('common.subCampaign')}:`} containerClass="mr-2"
              onChange={(e) => {
                setSelectedSubCampaignId(e.target.value);
              }}
            >  {subCampaings.map((item, index) => (<option key={`subcampaign ${index + 1}:`} value={item.id}>{item.name}</option>))}
            </SelectNesting>
          </div>

          <div className='d-flex flex-row align-items-center w-100 mt-3'>
            <div className="inputs" style={{ minWidth: 450 }}>
              <div className="input">
                <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                  <SelectNesting
                    id="minimum_passing_score" ref={minimum_passing_score_ref} className={'mt-1'}
                    boxInfo={true} tooltipText="" style={{ minWidth: 100, whiteSpace: 'nowrap' }}
                    title={`${t('menu.genai.minimumPassingScore')}:`} containerClass="mr-2 d-flex flex-row items-center"
                  >
                    {Array.from({ length: 100 }, (_, i) => i + 1).map((num) => (
                      <option key={`minimumpassing ${num + 1}:`} value={num} selected={num === minimum_passing_score_ref.current?.value}>
                        {num}
                      </option>
                    ))}
                  </SelectNesting>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 0 }} className='mt-2'>
            <label style={{ fontSize: 14, color: '#2E2E2E', fontWeight: 700, minWidth: 60 }}>Avatar:</label>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: 50, height: 50, border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
                  {avatarPreview ? <img src={avatarPreview} alt="avatar" style={{ maxWidth: '100%', maxHeight: '100%' }} /> : <img src="/avatar.png" alt="avatar" style={{ width: 36 }} />}
                </div>
                <div style={{ marginLeft: 8 }}>
                  <input type="file" accept="image/png,image/jpeg" onChange={handleAvatarChange} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
